import { createSlice } from "@reduxjs/toolkit";
import { set } from "date-fns";
import moment from "moment";

export const searchKeysSlice = createSlice({
  name: "searchKeys",
  initialState: {
    searchKeys: {
      selectedAgents: [],
      selectedCardStatus: "signedContract",
      dashboardStartDate: moment(new Date()),
      dashboardEndDate: moment(new Date()),

      // saver dashboard

      selectedAgentsSaver: [],
      selectedCardStatusSaver: "signedContract",
      dashboardStartDateSaver: moment(new Date()),
      dashboardEndDateSaver: moment(new Date()),

      // upgrade dashboard
      selectedAgentsUpgrade: [],
      selectedCardStatusUpgrade: "signedContract",
      dashboardStartDateUpgrade: moment(new Date()),
      dashboardEndDateUpgrade: moment(new Date()),

      leadSearchValue: "",
      leadSaleStatusValue: [],
      leadStartDate: "",
      leadEndDate: "",
      leadSelectedAgents: [],

      selectedAgentsForCalendar: [],

      calendarTabForAdmin: 1,
      calendarTabForAgent: 1,

      proposalSearchValue: "",

      adminCalendarStartDate: moment(new Date()),
      adminCalendarEndDate: moment(new Date()),

      reportSelectedAgents: [],
      selectedReportStatus: "",
      reportStartDate: moment(new Date()),
      reportEndDate: moment(new Date()),

      adminCalendarPageTab: 0,

      currentNotificationCount: 0,
    },
  },
  reducers: {
    setSearchKeys: (state, action) => {
      state.searchKeys = action.payload;
    },
    setSelectedAgents: (state, action) => {
      state.searchKeys.selectedAgents = action.payload;
    },
    setSelectedCardStatus: (state, action) => {
      state.searchKeys.selectedCardStatus = action.payload;
    },
    setDashboardStartDate: (state, action) => {
      state.searchKeys.dashboardStartDate = action.payload;
    },
    setDashboardEndDate: (state, action) => {
      state.searchKeys.dashboardEndDate = action.payload;
    },
    setSelectedAgentsSaver: (state, action) => {
      state.searchKeys.selectedAgentsSaver = action.payload;
    },
    setSelectedCardStatusSaver: (state, action) => {
      state.searchKeys.selectedCardStatusSaver = action.payload;
    },
    setDashboardStartDateSaver: (state, action) => {
      state.searchKeys.dashboardStartDateSaver = action.payload;
    },
    setDashboardEndDateSaver: (state, action) => {
      state.searchKeys.dashboardEndDateSaver = action.payload;
    },
    setSelectedAgentsUpgrade: (state, action) => {
      state.searchKeys.selectedAgentsUpgrade = action.payload;
    },
    setSelectedCardStatusUpgrade: (state, action) => {
      state.searchKeys.selectedCardStatusUpgrade = action.payload;
    },
    setDashboardStartDateUpgrade: (state, action) => {
      state.searchKeys.dashboardStartDateUpgrade = action.payload;
    },
    setDashboardEndDateUpgrade: (state, action) => {
      state.searchKeys.dashboardEndDateUpgrade = action.payload;
    },
    setLeadSearchValue: (state, action) => {
      state.searchKeys.leadSearchValue = action.payload;
    },
    setLeadSaleStatusValue: (state, action) => {
      state.searchKeys.leadSaleStatusValue = action.payload;
    },
    setLeadStartDate: (state, action) => {
      state.searchKeys.leadStartDate = action.payload;
    },
    setLeadEndDate: (state, action) => {
      state.searchKeys.leadEndDate = action.payload;
    },
    setLeadSelectedAgents: (state, action) => {
      state.searchKeys.leadSelectedAgents = action.payload;
    },
    resetDashboardSearchFilter: (state, action) => {
      state.searchKeys.selectedAgents = [];
      state.searchKeys.selectedCardStatus = "signedContract";
      state.searchKeys.dashboardStartDate = moment(new Date());
      state.searchKeys.dashboardEndDate = moment(new Date());
    },
    resetDashboardSearchFilterSaver: (state, action) => {
      state.searchKeys.selectedAgentsSaver = [];
      state.searchKeys.selectedCardStatusSaver = "signedContract";
      state.searchKeys.dashboardStartDateSaver = moment(new Date());
      state.searchKeys.dashboardEndDateSaver = moment(new Date());
    },
    resetDashboardSearchFilterUpgrade: (state, action) => {
      state.searchKeys.selectedAgentsUpgrade = [];
      state.searchKeys.selectedCardStatusUpgrade = "signedContract";
      state.searchKeys.dashboardStartDateUpgrade = moment(new Date());
      state.searchKeys.dashboardEndDateUpgrade = moment(new Date());
    },
    resetLeadSearchFilter: (state, action) => {
      state.searchKeys.leadSearchValue = "";
      state.searchKeys.leadSaleStatusValue = [];
      state.searchKeys.leadStartDate = "";
      state.searchKeys.leadEndDate = "";
      state.searchKeys.leadSelectedAgents = [];
    },
    setSelectedAgentsForCalendar: (state, action) => {
      state.searchKeys.selectedAgentsForCalendar = action.payload;
    },
    setCalendarTabForAdmin: (state, action) => {
      state.searchKeys.calendarTabForAdmin = action.payload;
    },
    setCalendarTabForAgent: (state, action) => {
      state.searchKeys.calendarTabForAgent = action.payload;
    },
    setProposalSearchValueForAgent: (state, action) => {
      state.searchKeys.proposalSearchValue = action.payload;
    },
    setAdminCalendarStartDate: (state, action) => {
      state.searchKeys.adminCalendarStartDate = action.payload;
    },
    setAdminCalendarEndDate: (state, action) => {
      state.searchKeys.adminCalendarEndDate = action.payload;
    },
    setReportStartDate: (state, action) => {
      state.searchKeys.reportStartDate = action.payload;
    },
    setReportEndDate: (state, action) => {
      state.searchKeys.reportEndDate = action.payload;
    },
    setReportSelectedAgents: (state, action) => {
      state.searchKeys.reportSelectedAgents = action.payload;
    },
    setReportSelectedStatus: (state, action) => {
      state.searchKeys.selectedReportStatus = action.payload;
    },
    reseReportSearchFilter: (state, action) => {
      state.searchKeys.reportSelectedAgents = [];
      state.searchKeys.selectedReportStatus = "";
      state.searchKeys.reportStartDate = moment(new Date());
      state.searchKeys.reportEndDate = moment(new Date());
    },
    setAdminCalendarPageTab: (state, action) => {
      state.searchKeys.adminCalendarPageTab = action.payload;
    },
    setCurrentNotificationCount: (state, action) => {
      state.searchKeys.currentNotificationCount = action.payload;
    },
  },
});

export const {
  setSearchKeys,
  setSelectedAgents,
  setSelectedCardStatus,
  setDashboardStartDate,
  setDashboardEndDate,
  resetDashboardSearchFilter,
  resetDashboardSearchFilterSaver,
  setSelectedAgentsSaver,
  setSelectedCardStatusSaver,
  setDashboardStartDateSaver,
  setDashboardEndDateSaver,
  setLeadSearchValue,
  setLeadSaleStatusValue,
  setLeadStartDate,
  setLeadEndDate,
  setLeadSelectedAgents,
  resetLeadSearchFilter,
  setSelectedAgentsForCalendar,
  setCalendarTabForAdmin,
  setCalendarTabForAgent,
  setProposalSearchValueForAgent,
  setAdminCalendarStartDate,
  setAdminCalendarEndDate,
  setReportStartDate,
  setReportEndDate,
  setReportSelectedAgents,
  setReportSelectedStatus,
  reseReportSearchFilter,
  setAdminCalendarPageTab,
  setCurrentNotificationCount,
  setSelectedAgentsUpgrade,
  setSelectedCardStatusUpgrade,
  setDashboardStartDateUpgrade,
  setDashboardEndDateUpgrade,
  resetDashboardSearchFilterUpgrade,
} = searchKeysSlice.actions;

export default searchKeysSlice.reducer;
